//module.exports = angular.module('agada.config')
//    .constant('DOMAIN_PATH', 'http://new.agadastories.org.il/')
//    .constant('AJAX_DOMAIN_PATH', 'https://api.agadastories.org.il')
//    .constant('PICTURE_PATH', 'https://api.agadastories.org.il/sites/default/files/agada_images/')
//    .constant('AUDIO_PATH', 'https://api.agadastories.org.il/sites/default/files/audio/')
//    .constant('PRESENTATION_PATH', 'https://new.agadastories.org.il/public/files/')  

module.exports = angular.module('agada.config')
    .constant('AJAX_DOMAIN_PATH', process.env.ENV === 'production' ? 'https://api.agadastories.org.il' : 'https://api.agadastories.org.il')
    .constant('PICTURE_PATH', '/files/agada_images/')
    .constant('AUDIO_PATH', '/files/audio/')
    .constant('PRESENTATION_PATH', '/files/')



//////////////////
// WEBPACK FOOTER
// ./config/localValues.js
// module id = 150
// module chunks = 0